"use client";

import { useState } from "react";
import { Button, Link, Text } from "@zapier/design-system";
import { useTranslations } from "@zapier/i18n";

import { TRASH_HREF } from "../AssetLayout/trashHref";
import styles from "./TrashNotification.module.css";

interface Props {
  message: React.ReactNode;
  /** Omitted when the trashed item(s) can't be restored (e.g. project Zaps). */
  onUndo?: () => void;
}

/** The "moved to trash" success toast body: message plus Undo / View trash actions. */
export function TrashNotification({ message, onUndo }: Props) {
  const t = useTranslations("buttons");
  const [isUndoing, setIsUndoing] = useState(false);

  return (
    <div className={styles.trashToast}>
      <Text>{message}</Text>
      <div className={styles.actions}>
        {onUndo && (
          <Button
            variant="secondary"
            size="small"
            isDisabled={isUndoing}
            onPress={() => {
              // One-shot: a second click can't retrigger the restore.
              setIsUndoing(true);
              onUndo();
            }}
          >
            {t("restore-undo")}
          </Button>
        )}
        {/* The unified trash page: this toast covers both Zaps and Canvases. */}
        <Link href={TRASH_HREF} variant="primary" size="small">
          {t("view-trash")}
        </Link>
      </div>
    </div>
  );
}
